/** The board the editor opens on when a screenshot is being taken.
 *
 * The editor is the one screen in this build with no game behind it, so the
 * harness has nothing to hand it: `app.go({kind:"editor"})` mounts
 * `EditorRoute`, and the draft `MapEditor` starts from is `EditorRoute`'s own
 * `useState(undefined)`. Every capture therefore photographed a blank 48x48
 * board of flat grass - which is a real first-launch state and a defensible
 * one, but it is not what the screen looks like in use, and it is the only
 * frame any critic has ever judged. Blind against the rest of the set it read
 * as the emptiest screen in the build by a wide margin.
 *
 * A prop would be the right shape and there is nowhere to put it: the host
 * component decides the draft and the debug surface may not reach into its
 * state. So the seam is here, one module-level slot, read ONCE when the
 * reducer is initialised and only when the host passed no `initial` of its
 * own - the host always wins, and a player who opens the editor has no fixture
 * set, so this is inert in every path but the harness's.
 */

import type { EditorDraft } from "./model.js";

let fixture: EditorDraft | null = null;

/** Set the board the next `MapEditor` mount opens on. Null clears it. */
export function setEditorFixture(draft: EditorDraft | null): void {
  fixture = draft;
}

/** The pending fixture board, or null. Read by `MapEditor` at mount. */
export function editorFixture(): EditorDraft | null {
  return fixture;
}
